var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import * as PropTypes from 'prop-types';
import * as classNames from 'classnames';
import util from './util';
var styles = util.styles;
/**
 * @hidden
 */
function iconElement(_a) {
    var imageUrl = _a.imageUrl, icon = _a.icon, iconClass = _a.iconClass, imageAlt = _a.imageAlt;
    if (imageUrl) {
        return (React.createElement("img", { role: "presentation", className: 'k-image', alt: imageAlt, src: imageUrl }));
    }
    else if (icon) {
        var iconClasses = classNames('k-icon', 'k-i-' + icon);
        return (React.createElement("span", { role: "presentation", className: iconClasses }));
    }
    else if (iconClass) {
        return (React.createElement("span", { role: "presentation", className: iconClass }));
    }
    return null;
}
/**
 * @hidden
 */
var Button = (function (_super) {
    __extends(Button, _super);
    function Button(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            active: (_this.props.selected === true && _this.props.togglable === true)
        };
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }
    Button.prototype.componentWillReceiveProps = function (props) {
        this.setState({ active: props.selected === true && this.props.togglable === true });
    };
    Button.prototype.render = function () {
        var _a = this.props, children = _a.children, look = _a.look, primary = _a.primary, selected = _a.selected, togglable = _a.togglable, icon = _a.icon, iconClass = _a.iconClass, imageUrl = _a.imageUrl, imageAlt = _a.imageAlt, className = _a.className, onClick = _a.onClick, htmlAttributes = __rest(_a, ["children", "look", "primary", "selected", "togglable", "icon", "iconClass", "imageUrl", "imageAlt", "className", "onClick"]);
        var buttonClasses = classNames([styles.button], (_b = {},
            _b[styles["" + look]] = look !== 'default',
            _b[styles.primary] = primary,
            _b[styles['state-disabled']] = this.props.disabled,
            _b[styles['state-active']] = this.state.active,
            _b[styles['button-icon']] = children === undefined,
            _b), [styles["" + this.props.dir]], className);
        var buttonProps = {
            className: buttonClasses,
            onClick: this.handleClick,
            // Accessibility properties
            role: togglable ? 'checkbox' : 'button',
            'aria-disabled': this.props.disabled || undefined,
            'aria-checked': this.state.active
        };
        var iconEl = iconElement({
            icon: icon,
            iconClass: iconClass,
            imageUrl: imageUrl,
            imageAlt: imageAlt
        });
        return (React.createElement("button", __assign({}, buttonProps, htmlAttributes),
            iconEl,
            children));
        var _b;
    };
    Button.prototype.activate = function () {
        if (this.props.togglable) {
            this.setState({ active: !this.state.active });
        }
    };
    Button.prototype.handleClick = function (event) {
        this.activate();
        if (this.props.onClick) {
            this.props.onClick.call(undefined, event);
        }
    };
    return Button;
}(React.Component));
export default Button;
Button.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.string]),
    look: PropTypes.oneOf(['default', 'bare', 'flat', 'outline']),
    primary: PropTypes.bool,
    selected: PropTypes.bool,
    togglable: PropTypes.bool,
    icon: PropTypes.string,
    iconClass: PropTypes.string,
    imageUrl: PropTypes.string,
    imageAlt: PropTypes.string,
};
Button.defaultProps = {
    look: 'default',
    primary: false,
    selected: false,
    togglable: false
};
//# sourceMappingURL=Button.js.map